export const milestoneCopy = {
  started: "Investigating",
  acknowledged: "Investigating",
  detected: "Investigating",
  investigating: "Investigating",
  identified: "Identified",
  mitigated: "Mitigated",
  resolved: "Resolved",
};
